// Last-activity stamp for the idle sign-out, per user in localStorage so every tab shares it and
// time with the app closed still counts. Sign-in stamps it; sign-out clears it.
const STORAGE_PREFIX = 'mea_last_activity_';

const storageKey = (userId: string) => `${STORAGE_PREFIX}${userId}`;

// Epoch ms of this user's last activity in any tab, or null if never stamped (or unreadable).
export const readLastActivityAt = (userId: string): number | null => {
  try {
    const parsed = Number(window.localStorage.getItem(storageKey(userId)));
    return parsed > 0 && Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const writeLastActivityAt = (userId: string, at: number): void => {
  try {
    window.localStorage.setItem(storageKey(userId), String(at));
  } catch {
    console.warn('idle-activity: failed to persist last activity; idle time is tracked in this tab only');
  }
};

export const clearLastActivityAt = (userId: string): void => {
  try {
    window.localStorage.removeItem(storageKey(userId));
  } catch {
    console.warn('idle-activity: failed to clear last activity');
  }
};
